// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interact_blur {
  width: 100vw;
  height: 100vw;
  max-height: 100vh;
  max-width: 100vw;
  opacity: 0.35;
  background-image: linear-gradient(to top, #27141f, #21131f, #1b121e, #15101c, #0f0e1a, #0f131f, #0e1823, #0d1c27, #0d2833, #0c343d, #0f4145, #194e4b);
  position: absolute;
}
.interact_name {
  position: absolute;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: #ffffff00;
}
.interact_name h1 {
  background: radial-gradient(ellipse, rgba(0, 0, 0, 0.3) 35%, rgba(14, 14, 14, 0.03) 62%, rgba(255, 255, 255, 0) 99%);
  padding: 5vw;
  text-align: right;
  margin-right: 30vw;
  color: #FFFFFF;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 2.5vw;
  line-height: 100%;
  max-width: 15vw;
  white-space: pre-line;
}
@keyframes fadeDown {
  0% {
    margin-bottom: -5vh;
  }
  100% {
    margin-bottom: 5vh;
  }
}
.interact_info {
  position: absolute;
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100vh;
  width: 100vw;
  background-color: #ffffff00;
  overflow: hidden;
}
.interact_info > div {
  margin-bottom: 5vh;
  animation: fadeDown 1.75s;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.1) 35%, rgba(14, 14, 14, 0.05) 62%, rgba(255, 255, 255, 0.01) 100%);
  display: flex;
  width: 50vw;
  justify-content: center;
  align-items: center;
}
.interact_info > div div {
  height: 8vh;
  width: 8vh;
  background: #FFFFFF00;
}
.interact_info > div h1 {
  text-align: center;
  color: #FFFFFF;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 1vw;
  line-height: 100%;
  margin-top: 0.6vw;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  text-align: left;
}
.interact_info > div h1 h2 {
  font-size: 1.3vw;
  margin: 0 1vw;
  text-transform: lowercase;
  color: #ffffff;
  text-align: center;
}
.interact_main {
  min-height: 100vh;
  max-width: 45vw;
  margin-left: 55vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 9999;
}
.interact_main .interact_scroll {
  padding-right: 1vw;
  display: flex;
  flex-direction: column;
  flex-flow: column;
  justify-content: flex-start;
}
.interact_main .interact_scroll .interact_item {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 6vw;
  padding-right: 2vw;
  cursor: pointer;
  padding: 0 2vw 0 2vw;
  font-family: TT Commons;
  font-style: normal;
  font-weight: normal;
  font-size: calc(0.5rem + 0.5vw);
  line-height: 100%;
  color: #FFFFFF;
}
.interact_main .interact_scroll .interact_item:hover {
  opacity: 0.99 !important;
}
.interact_main .interact_scroll .interact_item div {
  background: #0e0e0eee;
  height: 3vw;
  width: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1vw;
}
.interact_main .interact_scroll .interact_item div img {
  width: 3vw;
  height: 3vw;
}
.interact_main .interact_scroll .interact_item p {
  margin-left: 1vw;
  background: linear-gradient(90deg, #0e0e0eee 0%, rgba(38, 38, 38, 0.5) 100%);
  height: 3vw;
  width: 14vw;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 1vw;
}
`, "",{"version":3,"sources":["webpack://./src/components/interaction/assets/style.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACC,qJAAA;EACD,kBAAA;AACJ;AACA;EACI,kBAAA;EAEA,sBAAA;EAGA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,aAAA;EACA,YAAA;EACA,2BAAA;AAHJ;AAKI;EACI,oHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AAHR;AAMA;EACC;IACO,mBAAA;EAJN;EAME;IACI,kBAAA;EAJN;AACF;AAMA;EACI,kBAAA;EAEA,sBAAA;EACA,uBAAA;EAEA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EAEA,2BAAA;EACA,gBAAA;AAPJ;AAQI;EACI,kBAAA;EACA,yBAAA;EACA,uHAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AANR;AAOQ;EACC,WAAA;EACA,UAAA;EACA,qBAAA;AALT;AAOQ;EAEI,kBAAA;EAEA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EAKA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAXZ;AAYY;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EAEA,kBAAA;AAXhB;AAgBA;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAdJ;AAeI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;AAbR;AA6BQ;EAGI,sBAAA;EAEA,aAAA;EACA,mBAAA;EAGA,WAAA;EACA,kBAAA;EAKA,eAAA;EAIA,oBAAA;EAEI,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,cAAA;AAxChB;AA8BY;EACI,wBAAA;AA5BhB;AAwCY;EACI,qBAAA;EAEA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAvChB;AAwCgB;EACI,UAAA;EACA,WAAA;AAtCpB;AA0CY;EACI,gBAAA;EACA,4EAAA;EAEA,WAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAzChB","sourcesContent":[".interact_blur {\n    width: 100vw;\n    height: 100vw;\n    max-height: 100vh;\n    max-width: 100vw;\n    opacity: 0.35;\n     background-image: linear-gradient(to top, #27141f, #21131f, #1b121e, #15101c, #0f0e1a, #0f131f, #0e1823, #0d1c27, #0d2833, #0c343d, #0f4145, #194e4b);\n    position: absolute;\n}\n.interact_name {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n//    text-align: right;\n    height: 100vh;\n    width: 100vw;\n    background-color: #ffffff00;\n//    background: radial-gradient(circle, rgba(0,0,0,1) 35%, rgba(14,14,14,1) 62%, rgba(255,255,255,1) 100%);\n    & h1 {\n        background: radial-gradient(ellipse, rgba(0,0,0,0.3) 35%, rgba(14,14,14,0.03) 62%, rgba(255,255,255,0.0) 99%);\n        padding: 5.0vw;\n        text-align: right;\n        margin-right: 30vw;\n        color: #FFFFFF;\n        font-family: TT Commons;\n        font-style: normal;\n        font-weight: bold;\n        font-size: 2.5vw;\n        line-height: 100%;\n        max-width: 15vw;\n        white-space: pre-line;\n    }\n}\n@keyframes fadeDown {\n\t0% {\n        margin-bottom: -5vh;\n    }\n    100% {\n        margin-bottom: 5vh;\n    }\n}\n.interact_info {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 100vh;\n    width: 100vw;\n//    bottom: 5vh;\n    background-color: #ffffff00;\n    overflow: hidden;\n    &>div {\n        margin-bottom: 5vh;\n        animation: fadeDown 1.75s;\n        background: radial-gradient(circle, rgba(0,0,0,0.1) 35%, rgba(14,14,14,0.05) 62%, rgba(255,255,255,0.01) 100%);\n        display: flex;\n        width: 50vw;\n        justify-content: center;\n        align-items: center;\n        & div {\n         height: 8vh;\n         width: 8vh;\n         background: #FFFFFF00;\n        }\n        & h1 {\n//            padding: 2vw;\n            text-align: center;\n            //      margin-right: 30vw;\n            color: #FFFFFF;\n            font-family: TT Commons;\n            font-style: normal;\n            font-weight: bold;\n            font-size: 1.0vw;\n            line-height: 100%;\n            margin-top: 0.6vw;\n    //        max-width: 15vw;\n    //        white-space: pre-line;\n    //        white-space: nowrap;\n    //      word-wrap: none;\n            text-transform: uppercase;\n            display: flex;\n            justify-content: center;\n            text-align: left;\n            & h2 {\n                font-size: 1.3vw;\n                margin: 0 1vw;\n                text-transform: lowercase;\n                color: #ffffff;\n    //            background: radial-gradient(circle, rgba(0,0,0,0.2) 35%, rgba(14,14,14,0.05) 62%, rgba(255,255,255,0.01) 100%);\n                text-align: center;\n            }\n        }\n    }\n}\n.interact_main {\n    min-height: 100vh;\n    max-width: 45vw;\n    margin-left: 55vw;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    z-index: 9999;\n    & .interact_scroll {\n        padding-right: 1vw;\n        display: flex;\n        flex-direction: column;\n        flex-flow: column;\n        justify-content: flex-start;\n        // & .interact_item_free {\n        //     border-radius: 4px;\n        //     min-height: 6vh;\n        //     height: 4.5vw;\n        //     padding-right: 2vw;\n        //     margin: 0.5vw 0;\n        //     order: -1;\n        // } & .interact_item_free_end {\n        //     border-radius: 4px;\n        //     min-height: 6vh;\n        //     height: 4.5vw;\n        //     padding-right: 2vw;\n        //     margin: 0.5vw 0;\n        //     order: 1;\n        // }\n        & .interact_item {\n//            background: rgba(20, 27, 31, 0.8);\n//            border: 1px solid rgba(255, 255, 255, 0.3);\n            box-sizing: border-box;\n//            border-radius: 4px;\n            display: flex;\n            align-items: center;\n//            min-height: 6vh;\n//            height: 4.5vh;\n            height: 6vw;\n            padding-right: 2vw;\n  //          margin: 1.8vh 0;\n//            min-width: 10rem;\n  //          width: max-content;\n    //        max-width: 20rem;\n            cursor: pointer;\n            &:hover {\n                opacity: 0.99 !important;\n            }\n            padding: 0 2vw 0 2vw;\n            & {\n                font-family: TT Commons;\n                font-style: normal;\n                font-weight: normal;\n                font-size: calc( 0.5rem + 0.5vw );\n                line-height: 100%;\n                color: #FFFFFF;\n\n            }\n            & div {\n                background: #0e0e0eee;\n//                background: rgba(20, 27, 31, 0.8);\n                height: 3vw;\n                width: 3vw;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                padding: 1vw;\n                & img {\n                    width: 3vw;\n                    height: 3vw;\n    //                padding: 0 2vw 0 2vw;\n                }\n            }\n            & p {\n                margin-left: 1vw;\n                background: linear-gradient(90deg, #0e0e0eee 0%, rgba(38, 38, 38, 0.5) 100%);\n//                background: rgba(20, 27, 31, 0.8);\n                height: 3vw;\n                width: 14vw;\n                display: flex;\n                justify-content: left;\n                align-items: center;\n                padding: 1vw;\n//                text-align: left;\n\n            }\n        } \n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
